import React, { useState, useContext, useEffect } from 'react'
import { useScrollTop } from '../../hooks'

import FoldIcon from '../../images/fold.svg'
import ExpandIcon from '../../images/expand.svg'
import { useGPUInstanceNav, useStreamingServiceNav } from '../../hooks'
import { StateContext } from './state-context'
import { Section as NavSection, NavLink, FoldDiv } from '../nav-tree'

import withLocation from '../../common/with-location'

const GroupItem = withLocation(({ baseName, groupName, groupIndex, entries, Location }) => {
  const { setScrollTop } = useScrollTop('left-menu')
  const { state, dispatch } = useContext(StateContext)
  useEffect(() => {
    if (window) {
      const gIndex = window.localStorage.getItem('groupIndex') || 0
      dispatch({ type: 'setGroupIndex', payload: Location.hash ? +gIndex : -1 })
    }
  }, [dispatch, Location.hash])

  const handleLink = (e, id) => {
    if (Location.hash) {
      e.preventDefault()
      const top = document.getElementById(id)?.offsetTop || 0
      document.documentElement.scrollTop = top - 200
      if (window) {
        window.history.pushState('', `${baseName}`, `${Location.origin}${Location.pathname}#${id}`)
      }
    }
    dispatch({ type: 'setGroupIndex', payload: groupIndex })
    if (window) {
      window.localStorage.setItem('groupIndex', groupIndex)
    }
  }

  return (
    <>
      <NavLink
        rank={2}
        to={`/${baseName}/api-doc/#${entries[0].id}___${groupIndex}`}
        active={state.groupIndex === groupIndex ? 1 : 0}
        onClick={(e) => {
          setScrollTop()
          handleLink(e, entries[0].id + `___${groupIndex}`)
        }}
      >
        {groupName.replaceAll('_', ' ')}
      </NavLink>
    </>
  )
})

export function GPUNav() {
  const [fold, setFold] = useState(false)

  const data = useGPUInstanceNav()
  return (
    <>
      <FoldDiv rank={1} onClick={() => setFold(!fold)}>
        {process.env.GATSBY_LOCALE === 'zh' ? 'API文档' : 'API Documentation'}
        {fold ? <img src={FoldIcon} alt='fold icon' /> : <img src={ExpandIcon} alt='expand icon' />}
      </FoldDiv>
      <NavSection fold={fold}>
        {data.map((d, i) => (
          <GroupItem key={i} groupIndex={i} baseName='gpu-instance' {...d} />
        ))}
      </NavSection>
    </>
  )
}

export function StreamingNav() {
  const [fold, setFold] = useState(false)

  const data = useStreamingServiceNav()
  return (
    <>
      <FoldDiv rank={1} onClick={() => setFold(!fold)}>
        {process.env.GATSBY_LOCALE === 'zh' ? 'API文档' : 'API Documentation'}
        {fold ? <img src={FoldIcon} alt='fold icon' /> : <img src={ExpandIcon} alt='expand icon' />}
      </FoldDiv>
      <NavSection fold={fold}>
        {data.map((d, i) => (
          <GroupItem key={i} groupIndex={i} baseName='streaming-service' {...d} />
        ))}
      </NavSection>
    </>
  )
}
